var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvtar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 23.859,
    viewBox: "0 0 24 23.859",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576",
    transform: "translate(-13178 -4997.189)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5793",
    "data-name": "Rectangle 5793",
    transform: "translate(13178.189 4997.189)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.781,
    height: 23.83,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22.781,
    height: 22.83,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "person_FILL0_wght200_GRAD0_opsz24_1_",
    "data-name": "person_FILL0_wght200_GRAD0_opsz24 (1)",
    d: "M212-734.917a5.106,5.106,0,0,1-3.632-1.425,4.541,4.541,0,0,1-1.511-3.425,4.541,4.541,0,0,1,1.511-3.425A5.106,5.106,0,0,1,212-744.616a5.106,5.106,0,0,1,3.632,1.425,4.541,4.541,0,0,1,1.511,3.425,4.541,4.541,0,0,1-1.511,3.425A5.106,5.106,0,0,1,212-734.917Zm10.22,11.689H201.78a1.777,1.777,0,0,1-1.268-.483,1.577,1.577,0,0,1-.513-1.2v-.982a3.178,3.178,0,0,1,.618-1.873,4.09,4.09,0,0,1,1.663-1.354,25.308,25.308,0,0,1,4.856-1.646A22.013,22.013,0,0,1,212-731.31a22.013,22.013,0,0,1,4.863.549,25.308,25.308,0,0,1,4.856,1.646,4.089,4.089,0,0,1,1.663,1.354,3.178,3.178,0,0,1,.618,1.873v.982a1.577,1.577,0,0,1-.513,1.2A1.777,1.777,0,0,1,222.219-723.228Zm-20.505-1.617h20.571v-1.045a1.616,1.616,0,0,0-.368-1.01,2.922,2.922,0,0,0-1.017-.8,22.63,22.63,0,0,0-4.364-1.481,20.276,20.276,0,0,0-4.537-.514,20.276,20.276,0,0,0-4.537.514A22.631,22.631,0,0,0,203.1-727.7a2.923,2.923,0,0,0-1.017.8,1.616,1.616,0,0,0-.368,1.01ZM212-736.533a3.4,3.4,0,0,0,2.421-.95,3.027,3.027,0,0,0,1.007-2.283,3.027,3.027,0,0,0-1.007-2.283A3.4,3.4,0,0,0,212-743a3.4,3.4,0,0,0-2.421.95,3.027,3.027,0,0,0-1.007,2.283,3.027,3.027,0,0,0,1.007,2.283A3.4,3.4,0,0,0,212-736.533ZM212-739.766ZM212-724.844Z",
    transform: "translate(12978 5744.276)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvtar);
export default __webpack_public_path__ + "static/media/avtar.183a4cfa30975e9fcef495dad3db0509.svg";
export { ForwardRef as ReactComponent };